import { useEffect, useState } from 'react'

import { StatisticInfo, getSystemInfo } from '../../services'
import CardsWithInfo from '../CardsWithInfo/CardsWithInfo'
import PricesList from './PricesList/PricesList'

const Statistic = () => {
	const [statistic, setStatistic] = useState<StatisticInfo | null>(null)

	useEffect(() => {
		getSystemInfo().then((res) => {
			setStatistic(res.data)
		})
	}, [])

	const statisTicData = [
		{
			title: 'ORDERS',
			content: (
				<div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
						<span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<span style={{ fontSize: '20px', flexShrink: 0 }}>📈</span>
							<span style={{ 
								fontWeight: '700', 
								fontSize: '22px', 
								background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
								WebkitBackgroundClip: 'text',
								WebkitTextFillColor: 'transparent',
								backgroundClip: 'text'
							}}>
								{statistic?.blance || 0} R$
							</span>
						</span>
						<span style={{ color: '#9ca3af', fontSize: '16px' }}>
							total
						</span>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
						<span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<span style={{ fontSize: '20px', flexShrink: 0 }}>🔄</span>
							<span style={{ 
								fontWeight: '700', 
								fontSize: '22px', 
								background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
								WebkitBackgroundClip: 'text',
								WebkitTextFillColor: 'transparent',
								backgroundClip: 'text'
							}}>
								{statistic?.robuxReserved || 0} R$
							</span>
						</span>
						<span style={{ color: '#9ca3af', fontSize: '16px' }}>
							reserved orders
						</span>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0' }}>
						<span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<span style={{ fontSize: '20px', flexShrink: 0 }}>⏳</span>
							<span style={{ 
								fontWeight: '700', 
								fontSize: '22px', 
								background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
								WebkitBackgroundClip: 'text',
								WebkitTextFillColor: 'transparent',
								backgroundClip: 'text'
							}}>
								{statistic?.ordersCount || 0}
							</span>
						</span>
						<span style={{ color: '#9ca3af', fontSize: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
							pending orders
							<PricesList prices={statistic?.orderPrices ?? []} />
						</span>
					</div>
				</div>
			),
		},
	]

	return <CardsWithInfo cardData={statisTicData} />
}

export default Statistic
